module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0102.png.891c76d2.jpg";